import { combineReducers } from "redux";

import { generateCrudRedux, ICRUDReduxState } from "../../../../core/redux";
import { IClient, IClientForm } from "../../data/entities";
import { ClientRepoImpl } from "../../data/repo";

export const clientRedux = generateCrudRedux<IClient, IClientForm>({
  actionTypeName: "Client",
  repository: ClientRepoImpl,
});

export interface IClientReduxState extends ICRUDReduxState<IClient> {}

export const ClientReducers = combineReducers<IClientReduxState>({
  ...clientRedux.reducer,
});
